<template>
  <div id="aboutMobile">
    <div class="top">
      <div class="logo" v-if="!$store.state.cogir">
        <img src="@/assets/img/logo.png">
      </div>
      <div class="logo" v-if="$store.state.cogir">
        <img src="@/assets/img/logo-cogir.png" >
      </div>

    </div>
    <div class="description">
      <div class="title" v-if="!$store.state.cogir">{{ $t("about.title_2") }}</div>
      <div class="title" v-if="$store.state.cogir">{{ $t("about.cogir.title_2") }}</div>
      <div class="subtitle" v-if="!$store.state.cogir">{{ $t("about.subtitle") }}</div>
      <div class="text" v-if="!$store.state.cogir">
        <p :key="lineIndex" v-for="(line, lineIndex) of $t('about.description_humaniti')">
          {{ line }}
        </p>
      </div>
      <div class="text" v-if="$store.state.cogir">
        <p :key="lineIndex" v-for="(line, lineIndex) of $t('about.cogir.description')">
          {{ line }}
        </p>
      </div>
    </div>
    <div class="address" v-if="!$store.state.cogir">
      <div class="subtitle">{{ $t("about.contact_us") }}</div>
      1020 rue de Bleury<br>
      Montréal (Québec) H3A 2H7<br>
      -<br>
      1-514-444-2959<br>
      administration@humanitimontreal.com
    </div>
    <div class="address" v-if="$store.state.cogir">
      <div class="subtitle">{{ $t("about.contact_us") }}</div>
      7250, Taschereau boulevard, Suite 200<br>
      Brossard (Québec) J4W 1M9
    </div>
    <div class="contact">
      <ExternalLink v-if="!$store.state.cogir" class="button" url="tel:+1-514-444-2959" target="_system">
        <div class="icon">
          <img src="@/assets/img/icons/phone.png">
        </div>
        <div class="name">{{ $t("about.contact_us") }}</div>
      </ExternalLink>
      <ExternalLink v-if="$store.state.cogir" class="button" url="tel:+1-866-671-6381" target="_system">
        <div class="icon">
          <img src="@/assets/img/icons/phone.png">
        </div>
        <div class="name">{{ $t("about.call") }}</div>
      </ExternalLink>
      <ExternalLink v-if="!$store.state.cogir"class="button" url="mailto:administration@humanitimontreal.com" target="_system">
        <div class="icon">
          <img src="@/assets/img/icons/mail.png">
        </div>
        <div class="name">{{ $t("about.email") }}</div>
      </ExternalLink>
      <ExternalLink v-if="$store.state.cogir" class="button" url="mailto:info@cogir.net" target="_system">
        <div class="icon">
          <img src="@/assets/img/icons/mail.png">
        </div>
        <div class="name">{{ $t("about.email") }}</div>
      </ExternalLink>
      <ExternalLink class="button" :url="url" target="_blank">
        <div class="icon">
          <img src="@/assets/img/icons/website.png">
        </div>
        <div class="name">{{ $t("about.website") }}</div>
      </ExternalLink>
    </div>
    <div class="copyright">
      &copy; {{ (new Date()).getFullYear() }} {{$store.state.cogir ? 'Cogir' : 'Humaniti'}} <span class="version" v-if="CONFIG.version"> - Version {{CONFIG.version}}</span>
    </div>
  </div>
</template>

<script>
  import ExternalLink from "../ExternalLink";

  export default {
    name: "AboutMobile",

    components: { ExternalLink },

    data() {
      return {
        CONFIG,
        url: this.$store.state.cogir ? 'http://www.cogir.net/' : 'https://www.humanitimontreal.com/'
      }
    }
  }
</script>

<style lang="scss" scoped>

  #aboutMobile {
    overflow-x: hidden;
  }

  .top {
    height: 200px;
    background-image: url(../../assets/img/header-about.png);
    background-size: cover;
    background-position: center;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .logo {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }

  }

  .description {
    margin: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #d9dcde;
  }

  .address {
    padding: 0 20px;
    text-align: center;

    .subtitle {
      font-size: 12px;
      text-transform: uppercase;
      color: #bfc5c8;
      margin-bottom: 2px;
    }
  }

  .contact {
    display: flex;
    margin: 0 20px;
    padding: 20px 0;
    border-bottom: 1px solid #d9dcde;

    .button {
      flex-grow: 1;
      flex-basis: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #405159;

      .icon {
        width: 40px;
        height: 40px;
        background-color: #405159;
        border-radius: 50%;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .title {
    font-size: 24px;
    text-align: center;
    position: relative;
    margin-bottom: 30px;
    text-transform: uppercase;

    &:after {
      content: "";
      height: 5px;
      width: 60px;
      background-color: #bfc5c8;
      position: absolute;
      bottom: -17px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .subtitle {
    font-size: 18px;
    text-align: center;
  }

  .copyright {
    text-align: center;
    padding: 15px 0;
    opacity: 0.4;
    font-size: 12px;
    text-transform: uppercase;
  }

  /*.text {*/
  /*  text-align: justify;*/
  /*}*/
</style>
